import React from "react";
import Image from "next/legacy/image";
import cx from "classnames";
import { IWalletComponent } from "@novel/shared/components/ConnectWalletComponent/types";
import { CoinbaseCircleIcon } from "@novel/shared/icons";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import { AuthWallet } from "@novel/shared/utils/wallets/AuthWallet";
import Coinbase from "@novel/shared/icons/coinbase.svg";
export function CoinbaseWalletComponent({
  onConnectWallet,
  isInGate,
  AuthWalletClass = AuthWallet
}: IWalletComponent): JSX.Element {
  const connectCoinbase = useAsyncCallback(async () => {
    await new AuthWalletClass("coinbase").ensureWalletAppInstalled(async wallet => onConnectWallet(await wallet.authenticate()));
  }, [onConnectWallet]);
  return <React.Fragment>
            <div className={cx("connect-wallet-button", isInGate && "connect-wallet-button-in-gate")} onClick={connectCoinbase}>
                {isInGate ? <CoinbaseCircleIcon height="50px" width="50px" style={{
        height: "50px",
        width: "50px"
      }} /> : <Image alt="coinbase" src={Coinbase} layout="fixed" />}
                <div className={isInGate ? "connect-wallet-name-description-updated" : "connect-wallet-name-description"}>
                    <span className={isInGate ? "Connect-title-field-updated" : "Connect-title-field"}>
                        Coinbase
                    </span>
                </div>
            </div>
            {/* tweaking sdk library styles */}
            <style>{`
                .-cbwsdk-extension-dialog {
                    backdrop-filter: blur(5px);
                    -webkit-backdrop-filter: blur(5px);
                }

                .-cbwsdk-extension-dialog-box-top,
                .-cbwsdk-extension-dialog-box-bottom {
                    box-shadow: 4px 4px 10px rgb(0 0 0 / 30%) !important;
                }
            `}</style>
        </React.Fragment>;
}